<template>
	<v-row>
        <v-col cols="12">
			<v-select item-text="nome" item-value="id" :items="this.listaClas" v-model="this.iniciado.dados.idClaAtual" label="Clã" outlined></v-select>
        </v-col>
        <v-col cols="4">
			<v-text-field label="CPF" v-model="iniciado.outros.cpf" outlined></v-text-field>
        </v-col>
		<v-col cols="4">
			<v-text-field label="RG" v-model="iniciado.outros.rg" outlined></v-text-field>
        </v-col>
        <v-col cols="4">
			<v-text-field label="Profissão" v-model="iniciado.outros.profissao" outlined></v-text-field>
        </v-col>
        <v-col cols="4">
			<v-text-field label="Grau de Instrução" v-model="iniciado.outros.grauInstrucao" outlined></v-text-field>
        </v-col>
        <v-col cols="4">
			<v-select item-value="id" item-text="descricao" :items="this.listaStatus" v-model="iniciado.outros.status" label="Status" outlined v-show="verificaSePodeAcessar"></v-select>
        </v-col>
        <v-col cols="4">
			<v-text-field v-if="this.modo == 'novo'" label="Senha" v-model="iniciado.outros.senha" outlined></v-text-field>
        </v-col>
		<v-col cols="4">
			<v-text-field v-if="this.modo == 'novo'" label="Confirmar Senha" v-model="iniciado.outros.confirmarSenha" outlined></v-text-field>
        </v-col>
		<v-col cols="4">
			<!-- <v-select :items="this.listaPerfis" v-model="iniciado.outros.perfil" label="Perfil" outlined v-show="verificaSePodeAcessar"></v-select> -->
			<v-btn color="primary">Perfis</v-btn>
        </v-col>
	</v-row>
</template>
<script>
import { mapState } from 'vuex'
import metodos from '@/mixins/metodos'

	export default{
		props:['modo'],
		computed:{
			...mapState(['iniciado', 'listaStatus', 'listaPerfis', 'listaClas']),
		},
		mixins: [metodos],
		data(){
			return{
				
			}
		},
		created(){
		},
		watch:{
			"iniciado.dados.idClaAtual"(val){
			}
		}
	}
</script>
<style scoped>
	
	
</style>